import { UploadImgPreviewCommonStyle } from '@styles/base.style'
import styled from '@themes/theme'
import { ToggleBtnStyle } from '@views/Popup/Chat/ChatSettingPopup/index.style'

const pickLineHeight = '150%'
export const BeforeWriteWrap = styled.div`
  width: 100%;
  padding: 10px 18px;
  text-align: left;
  font-weight: ${props => props.theme.fontW.regular};
  font-size: ${props => props.theme.font.large};
  color: ${props => props.theme.color.disableTxt2};
`
export const TextAreaWrap = styled.div`
  width: 100%;
  height: auto;
  text-align: left;
  transition: none;

  .pick-comment-textarea {
    min-height: 100px !important;
    padding: 0 6px;
    margin: 0;
    line-height: ${pickLineHeight};
    color: ${props => props.theme.color.themeTxt};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.regular};
    border: none;
    resize: none;
    -webkit-user-select: auto;
    -webkit-touch-callout: default;
    transition: none;

    &::placeholder {
      color: ${props => props.theme.color.disableTxt2} !important;
      opacity: 1; /* Firefox */
    }

    &.ant-input:hover, &.ant-input:focus, &.ant-input:active {
      border: none !important;
    }

    &.error {
      color: ${props => props.theme.color.red};
    }

    &.user-pick {
      padding: 0 11px;
    }
  }

  .option-area {
    padding: 6px;

    .max-length {
      text-align: right;
      color: ${props => props.theme.color.btn};

      &.color-guide {
        color: ${props => props.theme.color.red};
      }
    }

    &.detail-bet-editor {
      .upload-preview {
        margin: 4px 0 0;
      }
    } 
  }

  .line {
    height: 1px;
    margin: 0 4px 6px;
    opacity: .2;
    background: ${props => props.theme.color.mainColor};
  }

  .textarea-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .upload-wrap {
      display: inline-flex;
      align-items: center;

      .upload-btn {
        width: 36px;
        height: 36px;
        margin-right: 3px;

        svg {
          width: 21px;
          height: auto;
          vertical-align: middle;

          .fill, .line {
            opacity: .8;
            fill: ${props => props.theme.color.themeTxt};
          }
        }

        &.upload-img {
          svg {
            width: 23px;
          }
        }

        &:hover {
          svg {
            .fill, .line {
              opacity: 1;
            }
          }
        }
      }

      .upload-img {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        &--input {
          position: absolute;
          left: 0;
          width: inherit;
          line-height: 30px;
          text-indent: 999px;
          overflow: hidden;
          color: transparent;
        }
      }
    }

    .btn-wrap {
      .cancel-btn, .send-btn {
        width: 60px;
        height: 36px;
        font-weight: ${props => props.theme.fontW.medium};
        border-radius: 6px;
      }

      .cancel-btn {
        margin-right: 4px;
        color: ${props => props.theme.color.modalSubBg2};
      }

      .send-btn {
        color: ${props => props.theme.color.btn};
        background: ${props => props.theme.color.mainColor};

        &.active {
          color: ${props => props.theme.color.underover};
        }
      }
    }
  }

  &.hide { /* display: none을 하게되면 error가 발생하여 너비 높이 값을 수정 */
    width: 0;
    height: 0;
    overflow: hidden;
  }

  // 댓글 작성 시 첨부영역
  .upload-preview {
    ${UploadImgPreviewCommonStyle};
    display: inline-block;

    &.uploaded-img {
      max-height: 180px;
    }

    &.textarea {
      margin-bottom: 12px;
      padding-top: 8px;

      & > *:not(.delete-preview-btn, .bottom-loading-wrap) {
        height: 78px;
        min-height: 78px;
      }

      .upload-img-preview {
        max-height: 100%;
      }
    }

    & > button {
      max-height: inherit;

      &.attachment-img-btn {
        border-radius: 6px;
        overflow: hidden;
      }
    }

    // 업로드 로딩
    .bottom-loading-wrap {
      height: auto;
      min-height: initial;
    }

    .delete-preview-btn {
      position: absolute;
      top: -12px;
      right: -22px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 44px;
      height: 44px;

      .bg {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: ${props => props.theme.color.mainColor};
        box-shadow: 1px 1px 2px rgba(0, 0, 0, .16);
      }

      .x-ico {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        &::before, &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg) scale(1.5);
          width: 1px;
          height: 8px;
          border-radius: 10px;
          background: ${props => props.theme.color.modalBg};
        }

        &::after {
          width: 8px;
          height: 1px;
        }
      }
    }
  }
`

export const CheerForTeamSelectAreaWrap = styled.div`
  display: flex;
  align-items: center;
  ${ToggleBtnStyle};
  padding: 0 10px 8px 10px;
  .cheer-for-team-emoticon-list {
    width: 207px;
    margin: 0 auto;
    transform: translateX(17px);
    background: ${props => props.theme.color.subColor};
  }
  &.disabled {
    opacity: .5;
    .cheer-for-team-emoticon-list {
      pointer-events : none;
    }
  }
`
